import type { VideoCollectionDto } from "../../shared/VideoCollectionDto";
import type { IVideoRepository } from "../interfaces/IVideoRepository";

export class VideoService {

    readonly repo: IVideoRepository;
    constructor(repo: IVideoRepository){
        this.repo = repo
    }


    async getAllVideoCollections(): Promise<VideoCollectionDto[]> {
        return await this.repo.getAll();
    }

}